import { FC, useCallback, useEffect, useRef } from "react";
import dayjs, { Dayjs } from "dayjs";
// Redux
import { useAppDispatch } from "app/hooks/useStore";
// Types
import UserRoles from "app/types/UserRoles";
// Async
import { getCalendarEventTypes } from "app/store/CalendarEventTypes/CalendarEventTypesAsync";
import { getUsers } from "app/store/Users/Users.async";
// Actions
import { CalendarEventsActions } from "app/store/CalendarEvents/CalendarEventsSlice";
// MUI
import { Box } from "@mui/material";
//
import CalendarBody from "./CalendarBody";
import CalendarToolbar from "./CalendarToolbar";
import CalendarSidebar from "./CalendarSidebar";
 
const CompanyCalendar:FC = () => {
  const dispatch = useAppDispatch();

  const calendarRef = useRef<any>(null);

  const handleDatesSet = useCallback(() => {
    if (calendarRef.current) {
      const api = calendarRef.current.getApi?.() || calendarRef.current?.currentData?.calendarApi;
      if (api) {
        dispatch(CalendarEventsActions.setCurrentDate(dayjs(api.getDate())));
        dispatch(CalendarEventsActions.setCurrentView(api.view.type));
      }
    }
    // eslint-disable-next-line
  }, [calendarRef]);

  const handleDateChange = (newDate: Dayjs) => {
    dispatch(CalendarEventsActions.setCurrentDate(newDate));
    calendarRef.current?.getApi().gotoDate(newDate.toDate());
  };
  
  useEffect(() => {
    dispatch(getCalendarEventTypes({}));
    dispatch(getUsers({ role: [UserRoles.Admin, UserRoles.Staff] }));
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ height: '100%', p: 4, display: 'flex', gap: 2 }}>
      <CalendarSidebar onDateChange={handleDateChange} />

      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <CalendarToolbar calendarRef={calendarRef} />
        <Box sx={{ flexGrow: 1, bgcolor: '#fff' }}>
          <CalendarBody calendarRef={calendarRef} onDatesSet={handleDatesSet} />
        </Box>
      </Box>
    </Box>
  );
}
 
export default CompanyCalendar;
